import { DatePipe, formatDate } from '@angular/common';
import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject, fromEvent, merge, Observable, of } from 'rxjs';
import { mapTo } from 'rxjs/operators';
import Swal from 'sweetalert2';

import * as CryptoJS from 'crypto-js';




@Injectable({
  providedIn: 'root',

})
export class UtilService {
  private resumeRequests: Map<string, Map<string, boolean>> = new Map(); // Map of candidateId to Map of recruiterId to boolean
  SWAL_BUTTONS = Swal.mixin({
    customClass: {
      confirmButton: 'btn btn-primary',
    },
    buttonsStyling: false
  });
  private resumeRequestsSource = new BehaviorSubject<Map<string, Map<string, boolean>>>(this.resumeRequests);
  resumeRequests$ = this.resumeRequestsSource.asObservable();
  online$: Observable<boolean>;
  networkValue: boolean = false;
  loaderValue: boolean = false;
  constructor(private spinner: NgxSpinnerService, private datePipe: DatePipe) {
    this.online$ = merge(
      of(navigator.onLine),
      fromEvent(window, 'online').pipe(mapTo(true)),
      fromEvent(window, 'offline').pipe(mapTo(false))
    )
    this.networkStatus()
  }

  log(message: string) {
  }

  public networkStatus() {
    this.online$.subscribe(value => {
      this.networkValue = value;
      if(!this.networkValue){
        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false
        });

        swalWithBootstrapButtons.fire({
          title: 'Oops! No Internet',
          text: "It seems that you are not connected to the internet. Please, connect and try again.",
          icon: 'info',
          showCancelButton: false,
          confirmButtonText: 'OK',
          reverseButtons: false
        })

      }
    })

  }

  startLoader(val?: any) {

    this.logCaller("inside");
    if (this.networkValue) {
      if (val == undefined || val === null || val === '')
        this.spinner.show();
      else
        this.spinner.show(val);

    } else {


      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false
      });

      swalWithBootstrapButtons.fire({
        title: 'Oops! No Internet',
        text: "It seems that you are not connected to the internet. Please, connect and try again.",
        icon: 'info',
        showCancelButton: false,
        confirmButtonText: 'OK',
        reverseButtons: false
      })



    }

  }


  stopLoader(val?: any) {
    // console.log("to find the where it end",val)
    this.logCaller("output");
    this.loaderValue = false;
    if (val == undefined || val === null || val === '')
      this.spinner.hide();
    else
      this.spinner.hide(val);
  }

  private logCaller(val) {
    const stack = new Error();
    // console.log('Called from:'+ val, stack);
  }


  blocked(){
   return this.SWAL_BUTTONS.fire({
      icon: 'error',
      title : 'User Blocked!',
      text: 'Your account has been blocked. Please contact admin to unblock it',
      showCancelButton: false,
      confirmButtonText: 'OK',
    });
  }

  interrupted(){
    return this.SWAL_BUTTONS.fire({
      icon: 'error',
      title : "App Access Disabled!",
      text: 'You are not allowed to log in. Please contact your admin.',
      showCancelButton: false,
      confirmButtonText: 'OK',
    });
  }

   // min-hour-sec-day getfrom this method

   dataconvert(curr, prev) {
    var ms_Min = 60 * 1000;
    var ms_Hour = ms_Min * 60;
    var ms_Day = ms_Hour * 24;
    var ms_Mon = ms_Day * 30;
    var ms_Yr = ms_Day * 365;
    var diff = curr - prev;

    let current = new Date(prev);
    var d1 = new Date(prev);
    const monthName = current.toLocaleString("default", { month: "long" })
    var date = monthName.substr(0, 3) + " " + current.getMonth();
    //  date +"-"+current.getFullYear();
    if (diff < ms_Min) {

      if (Math.round(diff / 1000) == 0) {
        return 'Just now';
      } else {
        return Math.round(diff / 1000) + ' sec';
      }

    } else if (diff < ms_Hour) {
      return Math.round(diff / ms_Min) + ' min';
    } else if (diff < ms_Day) {
      return Math.round(diff / ms_Hour) + 'hr';
    } else {
      return d1.toLocaleString('en-US');

    }
  }

  // check date greater
  checkGreaterDate(formDate, serverdate) {
    let fdate1 = formatDate(new Date(formDate), 'yyyy-MM-dd', 'en_US');
    let sdatet2 = formatDate(serverdate, 'yyyy-MM-dd', 'en_US');


    if (fdate1 == sdatet2) {

      return false;
    } else {

      return true;
    }
  }

  dateFormatestring(date: string): Date {
    // convert param date do browser time zone date




    if (date.includes('T')) {
      const splitDate = date.split('T')[0];
      const final = splitDate.split('-');
      const datess: Date = new Date();
      datess.setDate(+final[2])
      datess.setMonth(+final[1] - 1)
      datess.setFullYear(+final[0]);
      datess.setHours(0, 0, 0, 0);
      return datess;
    }

    return new Date(date);
  }

  formatDateddd(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
  }



  dateInPast(date) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date < today;
  }


  validformate(date) {
    let dates = formatDate(new Date(date), 'yyyy-MM-dd', 'en_US');
    return dates;

  }


  encrypt(value) {
    var encrypt = encodeURIComponent(CryptoJS.AES.encrypt(value, "Gigsumo!@#$%^&*()").toString());
    return encrypt;
  }
  decrypt(value) {

    var tempdata: CryptoJS.lib.WordArray = CryptoJS.AES.decrypt(decodeURIComponent(value), "Gigsumo!@#$%^&*()");

    var decrypt: any = tempdata.toString(CryptoJS.enc.Utf8);

    return decrypt;
  }

  updateResumeRequest(candidateId: string, recruiterId: string, status: boolean) {
    if (!this.resumeRequests.has(candidateId)) {
      this.resumeRequests.set(candidateId, new Map());
    }
    this.resumeRequests.get(candidateId).set(recruiterId, status);
    this.resumeRequestsSource.next(this.resumeRequests);
  }

  isResumeRequested(candidateId: string, recruiterId: string): boolean {
    return this.resumeRequests.has(candidateId) && this.resumeRequests.get(candidateId).get(recruiterId);
  }

  getValue(object: any[], key: string, type: string): string {
    const detail = object.find(detail => detail.benefitKey === key);
    if (type === 'available') {
      return detail ? detail.available : null;
    } else if (type === 'actual') {
      return detail ? detail.actual : null;
    }
  }


  mergeNames(firstName: string, lastName: string): string {
    return firstName + " " + lastName;
  }



  userAlias(userType: string): string {
    if (!userType) return '';
    const normalizedType = userType.replace(/_/g, ' ').toLowerCase();
    let alias: string;
    switch (normalizedType) {
      case 'management talent acquisition':
        alias = 'Manager';
        break;
      default:
        alias = normalizedType
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
        break;
    }
    return alias;
  }



}
